import { useState } from 'react';
import { Container } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';
import SideBar from '../../components/SideBar/SideBar';
import TopBar from '../../components/TopBar/TopBar';
import adminRoutes, { baseUrl } from '../../routes/routes';
import './Private.index.css';

export default function PrivateRoutes() {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className="xrg-layout">
            <SideBar
                menuData={adminRoutes}
                panelName="Admin"
                baseUrl={baseUrl}
                open={sidebarOpen}
            />

            <div className={'xrg-main' + (sidebarOpen ? ' xrg-main-shift' : '')}>
                <TopBar
                    sidebarOpen={sidebarOpen}
                    onToggleSidebar={() => setSidebarOpen((prev) => !prev)}
                />
                <Container fluid className="py-2">
                    <Outlet />
                </Container>
            </div>
        </div>
    );
}
